import { useAppRouter } from '@/common/route/useAppRouter';
import { validateDateAfter } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_QUEST } from '@/modules/quest/router';
import { questService } from '@/services/quest';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useQuestItemTime() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: route.params.itemId,
        name: null,
        startTime: null,
        endTime: null
    });

    const validations = {
        name: { required },
        startTime: { required },
        endTime: { validateDateAfer: validateDateAfter('startTime') }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => questService.item.get(model.id),
        onSuccess: ({ data }) => {
            model.name = data.name;
            model.startTime = data.startTime ? new Date(data.startTime) : null;
            model.endTime = data.endTime ? new Date(data.endTime) : null;
        },
        onError: () => router.push({ name: ROUTE_NAME_QUEST.ITEM.INDEX })
    });

    const actions = {
        updateTime: crudAction.excuteAndNotify({
            validator: v$,
            request: () => {
                const startTime = model.startTime.getTime();
                const endTime = model?.endTime ? model.endTime.getTime() : null;
                return questService.item.updateTime(model.id, startTime, endTime);
            },
            onSuccess: () => router.push({ name: ROUTE_NAME_QUEST.ITEM.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
